import React from "react";
export class BaseComponent extends React.Component {
    // this assumes that stores are injected by the classes that extend BaseComponent
    get stores() {
        return this.props.stores;
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYmFzZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL2Jhc2UudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sS0FBSyxNQUFNLE9BQU8sQ0FBQztBQVMxQixNQUFNLE9BQU8sYUFBaUMsU0FBUSxLQUFLLENBQUMsU0FBZTtJQUV6RSxpRkFBaUY7SUFDakYsSUFBSSxNQUFNO1FBQ1IsT0FBUSxJQUFJLENBQUMsS0FBb0IsQ0FBQyxNQUFpQixDQUFDO0lBQ3RELENBQUM7Q0FFRiJ9